import { SocietyTemplates } from 'types/Society';

export const INCENTIVES_MARKET_SOCIETY_TEMPLATES = {
  PURCHASE_CONTRACT: 'incentivesMarketPurchaseContract',
  TERMS_AND_CONDITIONS: 'incentivesMarketTermsAndConditions',
} as const;

type SocietyWithIncentivesMarketTemplates = {
  templates?: Pick<
    SocietyTemplates,
    | typeof INCENTIVES_MARKET_SOCIETY_TEMPLATES.PURCHASE_CONTRACT
    | typeof INCENTIVES_MARKET_SOCIETY_TEMPLATES.TERMS_AND_CONDITIONS
  >;
};

export const getIncentivesMarketPurchaseContractTemplateId = (
  society: SocietyWithIncentivesMarketTemplates | null | undefined
): string | undefined =>
  society?.templates?.[INCENTIVES_MARKET_SOCIETY_TEMPLATES.PURCHASE_CONTRACT];

export const getIncentivesMarketTermsAndConditionsTemplateId = (
  society: SocietyWithIncentivesMarketTemplates | null | undefined
): string | undefined =>
  society?.templates?.[INCENTIVES_MARKET_SOCIETY_TEMPLATES.TERMS_AND_CONDITIONS];
